import { gql } from '@apollo/client';

export const JOIN_LIVE_CLASSROOM_SUBSCRIPTION = gql`
  subscription JoinLiveClassroom($input: joinLiveClassroomInput!) {
    joinLiveClassroom(input: $input)
  }
`;
